var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewedTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 21,
    viewBox: "0 0 72 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-1.66909e-07 3L72 3L69 3.82535e-06L4 9.91233e-07L-1.66909e-07 3Z",
    fill: "#660035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 0L69 3.61636e-06L69 14.5105C69 15.3636 68.6935 16.2083 68.3351 16.9963C67.9767 17.7843 67.4513 18.5001 66.7891 19.1029C66.1269 19.7056 65.3408 20.1834 64.4758 20.509C63.6109 20.8345 62.684 21.0013 61.7482 21L10.9966 21C10.0618 21 9.13614 20.8321 8.27248 20.506C7.40881 20.1799 6.62406 19.7019 5.96304 19.0993C4.62804 17.8822 4 16.2316 4 14.5105L4 0Z",
    fill: "#BA0060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewedTag);
export default __webpack_public_path__ + "static/media/viewed_tag.478c5be65452068862246580f17647d1.svg";
export { ForwardRef as ReactComponent };